import { Formik, useFormikContext } from "formik";
import moment from "moment";
import { FC, useContext, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Column } from "react-table";
import { toast } from "react-toastify";
import AutocompleteV2 from "../../../component/AutocompleteObjectV2";
import DatePickerCustom from "../../../component/date-picker/DatePickerCustom";
import { getSimpleCategory, saveObsValue } from "../../../utils/ServicesUtils";
import { CODE, KEY, KEY_DS_DANH_MUC_TIEP_DON, ORDER_TYPE_ID, RESPONSE_MESSAGE, SELECTION_MODE, SIMPLE_CATEGORY_TYPE } from "../../../utils/Constant";
import { deleteDSChiDinhDV, getDSDVKhacDaChiDinh, getServiceListByType, updateOrderGroupFields } from "../../services/ChiDinhDVService";
import { TableCustomHeader } from "../../../component/table/components/TableCustomHeader";
import { TableCustomCell } from "../../../component/table/components/TableCustomCell";
import { formatDateTime } from "../../../utils/FormatUtils";
import LabelRequired from "../../../component/LabelRequired";
import DanhSachPhieu from "../../../component/DanhSachPhieu";
import { TableCustom } from "../../../component/table/table-custom/TableCustom";
import { PhanHeTiepDonContext } from "../../contexts/PhanHeTiepDonContext";
import ButtonInPhieu from "../../../component/button-in-phieu";
import { inPhieuChiDinhDVKhac } from "../../services/PrintExportService";
import WfButton from "../../../workflows/components/WfButton";
import { WfConstTrackerClinical } from "../../../workflows/Constant";
import DynamicComponentKB from "../../components/DynamicComponentKB";
import { getBedCategory } from "../../../phan-he-noi-tru/services/HanhChinhServices";
import { WORKFLOW_ORDER_GROUP_STATUS_CODE } from "../../constants/ChiDinhDVConst";
import { TimeEditor } from "src/app/modules/component/time-editor/TimeEditor";
import { useTimeEditorManager } from "src/app/modules/component/time-editor/useTimeEditorManager";
import { hasAuthority, KEY_AUTHORITIES } from "src/app/modules/utils/Permission";
import { SelectEditor, useSelectEditorManager } from "src/app/modules/component/select-editor";
import { seachUserMetadata } from "src/app/modules/auth/core/_requests";
import useIndexDBValue from "src/app/hook/useIndexDBValue";
import { IDanhSachDanhMuc } from "src/app/modules/phan-he-tiep-nhan-thanh-toan/models/TiepDonModel";

const COLUMN_ID = {
    LOAI_NGAY_GIUONG: "LOAI_NGAY_GIUONG",
    NGAY_VAO: "NGAY_VAO",
    NGAY_RA: "NGAY_RA",
    MA_GIUONG: "MA_GIUONG",
}

const GenerateInput: FC<any> = ({
    rowData,
    colData,
    dsLoaiNgayGiuong,
    handleChangeObsValue,
    setSelectedRow,
    setSelectedCol,
    bedCategory,
}) => {
    const { values, setFieldValue, setValues } = useFormikContext<any>() || {};
    useEffect(() => {
        setValues({
            ...values,
            bedTypeName: rowData?.obs?.bedTypeName,
            bedDayStartDate: rowData?.obs?.bedDayStartDate,
            bedDayEndDate: rowData?.obs?.bedDayEndDate,
        });
    }, []);

    switch (colData?.id) {
        case COLUMN_ID.MA_GIUONG:
            return (
                <AutocompleteV2
                    autoFocus
                    options={bedCategory}
                    value={{ code: values?.bedCode, name: values.bedName }}
                    name="bedCode"
                    getOptionValue={(option: any) => option?.code}
                    onChange={(selectedOption) => {
                        setFieldValue?.('bedName', selectedOption?.name);
                        setFieldValue?.('bedCode', selectedOption?.code);
                        setFieldValue?.('bedCodeIns', selectedOption?.codeIns);
                    }}
                    onBlur={() => {
                        handleChangeObsValue(
                            values?.bedCode
                                ? {
                                    bedCode: values?.bedCode,
                                    bedName: values?.bedName,
                                    bedCodeIns: values?.bedCodeIns
                                }
                                : null
                        );
                        setSelectedRow?.(null);
                        setSelectedCol?.(null);
                    }}
                    className="spaces width-100 h-28"
                    isClearable={false}
                />
            );
        case COLUMN_ID.LOAI_NGAY_GIUONG:
            return (
                <AutocompleteV2
                    autoFocus
                    options={dsLoaiNgayGiuong}
                    value={{ bedTypeName: values?.bedTypeName }}
                    name="bedTypeName"
                    getOptionLabel={(option: any) => option?.bedTypeName}
                    onChange={(selectedOption) => {
                        setFieldValue?.('bedTypeName', selectedOption?.bedTypeName);
                        setFieldValue?.('bedTypeCode', selectedOption?.code);
                    }}
                    onBlur={() => {
                        handleChangeObsValue(
                            values?.bedTypeName
                                ? {
                                    bedTypeName: values?.bedTypeName,
                                    bedTypeCode: values?.bedTypeCode,
                                }
                                : null
                        );
                        setSelectedRow?.(null);
                        setSelectedCol?.(null);
                    }}
                    className="spaces width-100 h-28"
                    isClearable={false}
                />
            );
        case COLUMN_ID.NGAY_VAO:
            return (
                <DatePickerCustom
                    autoFocus
                    name="bedDayStartDate"
                    labelClassName="ms-0 min-w-100px"
                    value={values?.bedDayStartDate}
                    setDateValue={(date) => {
                        setFieldValue?.('bedDayStartDate', date);
                    }}
                    {...{
                        [values?.bedDayStartDate ? 'handleBlur' : 'onClickOutside']: () => {
                            handleChangeObsValue(
                                values?.bedDayStartDate
                                    ? { bedDayStartDate: values?.bedDayStartDate }
                                    : null
                            );
                            setSelectedRow?.(null);
                            setSelectedCol?.(null);
                        },
                    }}
                    mode="date-time"
                    popperPlacement="left"
                />
            );
        case COLUMN_ID.NGAY_RA:
            return (
                <DatePickerCustom
                    autoFocus
                    name="bedDayEndDate"
                    labelClassName="ms-0 min-w-100px"
                    value={values?.bedDayEndDate}
                    setDateValue={(date) => {
                        setFieldValue?.('bedDayEndDate', date);
                    }}
                    {...{
                        [values?.bedDayEndDate ? 'handleBlur' : 'onClickOutside']: () => {
                            handleChangeObsValue(
                                values?.bedDayEndDate
                                    ? { bedDayEndDate: values?.bedDayEndDate }
                                    : null
                            );
                            setSelectedRow?.(null);
                            setSelectedCol?.(null);
                        },
                    }}
                    mode="date-time"
                    popperPlacement="left"
                />
            );
        default:
            return null;
    }
};

interface Iprops {
    generalInfo?: any;
    onUpdate?: () => void;
};

export const TabDVKhac = ({ generalInfo = {}, onUpdate}: Iprops) => {
    const { benhNhanInfo, setBenhNhanInfo, statusChangedEventFunc } = useContext(PhanHeTiepDonContext);
    let { visit, patient, isConclusion, orderId } = benhNhanInfo?.thongTinKhamBenh || generalInfo;
    const [dsPhieu, setDsPhieu] = useState<any[]>([]);
    const [selectedPhieu, setSelectedPhieu] = useState<any>([]);
    const [dsXetNghiemDetail, setDsXetNghiemDetail] = useState<any[]>([]);
    const [dsLoaiNgayGiuong, setDsLoaiNgayGiuong] = useState<any[]>([]);
    const [selectedRow, setSelectedRow] = useState<any>(null);
    const [selectedCol, setSelectedCol] = useState<any>(null);
    const [dynamicData, setDynamicData] = useState<any>(null);
    const [selectedIndex, setSelectedIndex] = useState<any>(0);
    const [isUpdateWorkflow, setIsUpdateWorkflow] = useState(false);
    const [bedCategory, setBedCategory] = useState([]);
    const [currentStatusWf, setCurrentStatusWf] = useState<string>();
    const [currentOrderId, setCurrentOrderId] = useState<string>(orderId);

    const { value: danhSachDanhMuc } = useIndexDBValue<IDanhSachDanhMuc>({
        key: KEY_DS_DANH_MUC_TIEP_DON,
    });

    const allowEdit = !isConclusion && hasAuthority(KEY_AUTHORITIES.UPDATE_FIELDS.PHIEU_CHI_DINH);

    //  Sử dụng custom hook để quản lý indication time
    const indicationTimeManager = useTimeEditorManager({
        name: "indicationTime",
        values: selectedPhieu,
        updateFields: updateOrderGroupFields,
        onUpdateSuccess: (updatedData) => {
            if (!updatedData?.indicationTime) return;
            // Cập nhật selectedPhieu với data mới
            setSelectedPhieu((prev: any) => ({
                ...prev,
                indicationTime: updatedData.indicationTime
            }));

            // Cập nhật trong danh sách phiếu
            setDsPhieu((prevList: any[]) =>
                prevList.map((phieu: any) =>
                    phieu.id === selectedPhieu?.id
                        ? { ...phieu, indicationTime: updatedData.indicationTime, date: moment(updatedData.indicationTime).format("DD/MM/YYYY") }
                        : phieu
                )
            );
        }
    });

    const indicationPersonSelectManager = useSelectEditorManager({
        name: "indicationPerson",
        idFieldName: "id",
        values: selectedPhieu,
        updateFields: updateOrderGroupFields,
        buildPayload: (option) => ({
            indicationPerson: option?.fullName,
            indicationTime: selectedPhieu?.indicationTime
        }),
        onUpdateSuccess: (updatedData) => {
            if (!updatedData?.indicationPerson) return;
            // Cập nhật selectedPhieu với data mới
            setSelectedPhieu((prev: any) => ({
                ...prev,
                indicationPerson: updatedData.indicationPerson
            }));

            // Cập nhật trong danh sách phiếu
            setDsPhieu((prevList: any[]) =>
                prevList.map((phieu: any) =>
                    phieu.id === selectedPhieu?.id
                        ? { ...phieu, indicationPerson: updatedData.indicationPerson }
                        : phieu
                )
            );
        },
        enableConfirmWithReason: false, // Không dùng confirm with reason cho trường hình thức
    });

    const requestDeptNameSelectManager = useSelectEditorManager({
        name: "requestDeptName",
        idFieldName: "id",
        values: selectedPhieu,
        updateFields: updateOrderGroupFields,
        buildPayload: (option) => ({
            requestDeptCode: option?.code,
            requestDeptName: option?.name,
            indicationTime: selectedPhieu?.indicationTime
        }),
        onUpdateSuccess: (updatedData) => {
            if (!updatedData?.requestDeptName) return;
            // Cập nhật selectedPhieu với data mới
            setSelectedPhieu((prev: any) => ({
                ...prev,
                requestDeptName: updatedData.requestDeptName
            }));

            // Cập nhật trong danh sách phiếu
            setDsPhieu((prevList: any[]) =>
                prevList.map((phieu: any) =>
                    phieu.id === selectedPhieu?.id
                        ? { ...phieu, requestDeptName: updatedData.requestDeptName }
                        : phieu
                )
            );
        },
        enableConfirmWithReason: false,
    });

    const handleUpdate = () => {
        if (onUpdate) {
            onUpdate();
        } else {
            setBenhNhanInfo({
                ...benhNhanInfo,
                shouldUpdate: !benhNhanInfo?.shouldUpdate,
            });
            statusChangedEventFunc?.();
        }
    };

    const actionChanged = (statusCode?: string) => {
        setCurrentStatusWf(statusCode);
        handleSelectPhieu(selectedPhieu);
        handleUpdate();
        setIsUpdateWorkflow(!isUpdateWorkflow);
        toast.success(RESPONSE_MESSAGE.SUCCESS);
    };

    const handleReset = () => {
        setDsPhieu([]);
        setSelectedPhieu(null);
        setDsXetNghiemDetail([]);
    };

    const handleClickWfButton = (data: any) => {
        setDynamicData({
            ...data,
            orderGroupId: selectedPhieu?.id,
            callbackFunc: () => {
                setSelectedIndex(0);
            },
            updateWorkflow: () => {
                setIsUpdateWorkflow(!isUpdateWorkflow);
            }
        });
    };

    const handleConfirmDelete = async () => {
        try {
            await deleteDSChiDinhDV(selectedPhieu?.id);
            handleUpdate();
            setSelectedIndex(0);
        } catch (error) {
            console.error(error);
            toast.error("Xảy ra lỗi, vui lòng thử lại!");
        }
    }

    const handleChangeObsValue = async (obsValue: any) => {
        try {
            if (!obsValue) return;
            let submitData = {
                personId: selectedRow?.personId,
                visitId: selectedRow?.visitId,
                encounterId: selectedRow?.encounterId,
                orderId: selectedRow?.orderId,
                values: obsValue
            };
            let { data } = await saveObsValue(submitData);
            if (CODE.SUCCESS === data?.code) {
                handleSelectPhieu(selectedPhieu);
                toast.success("Thành công");
            } else {
                let errorMessage = data?.data?.[0]?.errorMessage || data?.message;
                toast.warn(errorMessage);
            };
        } catch (error) {
            console.error(error);
        }
    };

    const handleSelectPhieu = async (dataPhieu: any) => {
        if (!dataPhieu) {
            handleReset();
            return;
        };
        setSelectedPhieu(dataPhieu);
        setSelectedIndex(dataPhieu?.index);
        try {
            setSelectedPhieu(dataPhieu);
            let { data } = await getDSDVKhacDaChiDinh({
                orderGroupId: dataPhieu?.id,
            });
            if (CODE.SUCCESS === data?.code) {
                setDsXetNghiemDetail(data?.data || []);
            } else {
                setDsXetNghiemDetail([]);
            }
        } catch (error) {
            console.error(error);
            setDsXetNghiemDetail([]);
        }
    };

    const handleGetDsPhieu = async () => {
        try {
            let { data } = await getServiceListByType({
                visitId: visit?.id, 
                type: ORDER_TYPE_ID.DV_KHAC
            });
            if (CODE.SUCCESS === data?.code) {
                let dsPhieuConverted = data?.data?.map((item: any, index: number) => {
                    return {
                        ...item,
                        index,
                        date: moment(item?.indicationTime).format("DD/MM/YYYY"),
                    };
                });
                let currentIndex = orderId !== currentOrderId ? 0 : selectedIndex;
                setDsPhieu(dsPhieuConverted || []);
                handleSelectPhieu(dsPhieuConverted?.[currentIndex] || dsPhieuConverted?.[0]);
            } else {
                handleReset();
            }
        } catch (error) {
            console.error(error);
            handleReset();
        }
    };

    const handleGetDsLoaiNgayGiuong = async () => {
        try {
            let { data } = await getSimpleCategory({
                type: SIMPLE_CATEGORY_TYPE.LOAI_NGAY_GIUONG
            });
            if (CODE.SUCCESS === data?.code) {
                let result = data?.data?.content?.map((item: any) => ({
                    ...item,
                    bedTypeName: item?.name
                }));
                setDsLoaiNgayGiuong(result || []);
            } else {
                setDsLoaiNgayGiuong([]);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const getBeds = async () => {
        try {
            const { code, data } = await getBedCategory({
                pageIndex: 1,
                pageSize: 9999,
                // deptDepartmentId: benhNhanHanhChinh?.deptId
            });

            if (CODE.SUCCESS === code && data) {
                setBedCategory(data.content);
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        handleGetDsLoaiNgayGiuong();
        getBeds();
    }, []);

    useEffect(() => {
        setCurrentOrderId(orderId);
    }, [orderId]);

    useEffect(() => {
        if (orderId) {
            handleGetDsPhieu();
        }
    }, [benhNhanInfo?.shouldUpdate, generalInfo?.updateTab, orderId]);

    useEffect(() => {
        selectedPhieu && setCurrentStatusWf(selectedPhieu?.currStatusCode);
    }, [selectedPhieu]);

    const columns: ReadonlyArray<Column<any>> = [
        {
            Header: (props) => (
                <TableCustomHeader
                    tableProps={props}
                    title={"STT"}
                    className=" text-center text-white"
                />
            ),
            id: "STT",
            Cell: ({ ...props }) => (
                <TableCustomCell className="text-center" data={(props.row.index + 1).toString()} />
            ),
        },
        {
            Header: (props) => (
                <TableCustomHeader<any>
                    tableProps={props}
                    title='Tên dịch vụ'
                    className=' min-w-200px text-center '
                />
            ),
            id: 'Tên dịch vụ',
            Cell: ({ ...props }) => (
                <TableCustomCell className='min-w-150px ' data={props.data[props.row.index]?.termName || ""} />
            ),
        },
        {
            Header: (props) => (
                <TableCustomHeader<any>
                    tableProps={props}
                    title='SL'
                    className=' text-center '
                />
            ),
            id: 'Số lượng',
            Cell: ({ ...props }) => (
                <TableCustomCell className='min-w-50px text-center ' data={props.data[props.row.index]?.soLuong || 1} />
            ),
        },
        {
            Header: (props) => (
                <TableCustomHeader<any>
                    tableProps={props}
                    title='Mã giường'
                    className='min-w-100px text-center'
                />
            ),
            id: COLUMN_ID.MA_GIUONG,
            Cell: ({ ...props }) => {
                const rowData = props?.data[props?.row?.index];
                const colData = props?.column;
                const propsInput = {
                    rowData,
                    colData,
                    bedCategory,
                    handleChangeObsValue,
                    setSelectedRow,
                    setSelectedCol,
                };
                const editable = rowData?.isBedDayService
                    && selectedRow?.index === props?.row?.index
                    && colData?.id === selectedCol?.id;

                return (
                    <>
                        {editable ? (
                            <GenerateInput {...propsInput} />
                        ) : (
                            <div
                                className="text-system spaces h-28 line-height-28"
                                onClick={() => {
                                    setSelectedRow?.({ ...rowData, index: props?.row?.index });
                                    setSelectedCol?.(colData);
                                }}
                            >
                                {rowData?.obs?.bedCode || ''}
                            </div>
                        )}
                    </>
                );
            }
        },
        {
            Header: (props) => (
                <TableCustomHeader<any>
                    tableProps={props}
                    title='Loại ngày giường'
                    className='min-w-200px  text-center'
                />
            ),
            id: COLUMN_ID.LOAI_NGAY_GIUONG,
            Cell: ({ ...props }) => {
                let rowData = props?.data[props?.row?.index];
                let colData = props?.column;
                let propsInput = { rowData, colData, dsLoaiNgayGiuong, handleChangeObsValue, setSelectedRow, setSelectedCol };
                return <>
                    {rowData?.isBedDayService && selectedRow?.index === props?.row?.index && colData?.id === selectedCol?.id ? (
                        <GenerateInput {...propsInput} />
                    ) : (
                        <div
                            className={`spaces h-28`}
                            onClick={() => {
                                setSelectedRow?.({ ...rowData, index: props?.row?.index });
                                setSelectedCol?.(colData);
                            }}
                        >
                            {rowData?.obs?.bedTypeName || ""}
                        </div>
                    )}
                </>
            }
        },
        {
            Header: (props) => (
                <TableCustomHeader<any>
                    tableProps={props}
                    title='Ngày vào'
                    className='min-w-100px text-center'
                />
            ),
            id: COLUMN_ID.NGAY_VAO,
            Cell: ({ ...props }) => {
                let rowData = props?.data[props?.row?.index];
                let colData = props?.column;
                let propsInput = { rowData, colData, dsLoaiNgayGiuong, handleChangeObsValue, setSelectedRow, setSelectedCol };
                return <>
                    {selectedRow?.index === props?.row?.index && colData?.id === selectedCol?.id ? (
                        <GenerateInput {...propsInput} />
                    ) : (
                        <div
                            className={`spaces h-28`}
                            onClick={() => {
                                setSelectedRow?.({ ...rowData, index: props?.row?.index });
                                setSelectedCol?.(colData);
                            }}
                        >
                            {rowData?.obs?.bedDayStartDate ? formatDateTime(rowData?.obs?.bedDayStartDate) : ""}
                        </div>
                    )}
                </>
            }
        },
        {
            Header: (props) => (
                <TableCustomHeader<any>
                    tableProps={props}
                    title='Ngày ra'
                    className='min-w-100px text-center'
                />
            ),
            id: COLUMN_ID.NGAY_RA,
            Cell: ({ ...props }) => {
                let rowData = props?.data[props?.row?.index];
                let colData = props?.column;
                let propsInput = { rowData, colData, dsLoaiNgayGiuong, handleChangeObsValue, setSelectedRow, setSelectedCol };
                return <>
                    {selectedRow?.index === props?.row?.index && colData?.id === selectedCol?.id ? (
                        <GenerateInput {...propsInput} />
                    ) : (
                        <div
                            className={`spaces h-28`}
                            onClick={() => {
                                setSelectedRow?.({ ...rowData, index: props?.row?.index });
                                setSelectedCol?.(colData);
                            }}
                        >
                            {rowData?.obs?.bedDayEndDate ? formatDateTime(rowData?.obs?.bedDayEndDate) : ""}
                        </div>
                    )}
                </>
            }
        },
    ]

    return (
        <Row className="h-100 spaces">
            <div>
                <div className="pt-4 bg-white">
                    <Row className="mx-0">
                        <Col xs={4} className="d-flex align-items-center mb-3">
                            <LabelRequired label="Mã phiếu" className="min-w-100px" />
                            <span className="fw-light text-truncate">
                                {selectedPhieu?.code || "..."}
                            </span>
                        </Col>
                        <Col xs={4} className="d-flex align-items-center text-lable-input mb-3">
                            <LabelRequired label="Ngày y lệnh" className="min-w-100px" />
                            <TimeEditor
                                name="indicationTime"
                                values={selectedPhieu}
                                isEditingTime={indicationTimeManager.isEditingTime}
                                editedTime={indicationTimeManager.editedTime}
                                showValidationConfirm={indicationTimeManager.showValidationConfirm}
                                validationMessage={indicationTimeManager.validationMessage}
                                onEdit={indicationTimeManager.handleEditTime}
                                onCancel={indicationTimeManager.handleCancelEdit}
                                onSave={indicationTimeManager.handleSaveTime}
                                onConfirmValidation={indicationTimeManager.handleConfirmValidation}
                                onCancelValidation={indicationTimeManager.handleCancelValidation}
                                onTimeChange={indicationTimeManager.setEditedTime}
                                allowEdit={allowEdit}
                            />
                        </Col>
                        <Col
                            xs={4}
                            className="d-flex align-items-center text-lable-input mb-3"
                        >
                            <LabelRequired label="Người chỉ định" className="min-w-100px" />
                            <SelectEditor
                                name="indicationPerson"
                                values={{
                                    indicationPerson: selectedPhieu?.indicationPerson
                                }}
                                options={[]}
                                searchFunction={seachUserMetadata}
                                searchObject={{ position: 1 }}
                                urlData="data.content"
                                getOptionLabel={(opt) => opt?.fullName || ""}
                                inline={true}
                                menuPlacement="top"
                                isEditingSelect={indicationPersonSelectManager.isEditingSelect}
                                editedValue={indicationPersonSelectManager.editedValue}
                                showValidationConfirm={indicationPersonSelectManager.showValidationConfirm}
                                showConfirmWithReason={indicationPersonSelectManager.showConfirmWithReason}
                                validationMessage={indicationPersonSelectManager.validationMessage}
                                onEdit={indicationPersonSelectManager.handleEditSelect}
                                onCancel={indicationPersonSelectManager.handleCancelEdit}
                                onSave={indicationPersonSelectManager.handleSaveSelect}
                                onConfirmValidation={indicationPersonSelectManager.handleConfirmValidation}
                                onCancelValidation={indicationPersonSelectManager.handleCancelValidation}
                                onConfirmWithReason={indicationPersonSelectManager.handleConfirmWithReason}
                                onCancelWithReason={indicationPersonSelectManager.handleCancelWithReason}
                                onValueChange={indicationPersonSelectManager.setEditedValue}
                                allowEdit={allowEdit}
                            />
                        </Col>
                        <Col
                            xs={4}
                            className="d-flex align-items-center text-lable-input mb-3"
                        >
                            <LabelRequired label="Nơi chỉ định" className="min-w-100px" />
                            <SelectEditor
                                name="requestDeptName"
                                values={{
                                    requestDeptName: selectedPhieu?.requestDeptName
                                }}
                                options={danhSachDanhMuc?.listPhongKham || []}
                                inline={true}
                                menuPlacement="top"
                                isEditingSelect={requestDeptNameSelectManager.isEditingSelect}
                                editedValue={requestDeptNameSelectManager.editedValue}
                                showValidationConfirm={requestDeptNameSelectManager.showValidationConfirm}
                                showConfirmWithReason={requestDeptNameSelectManager.showConfirmWithReason}
                                validationMessage={requestDeptNameSelectManager.validationMessage}
                                onEdit={requestDeptNameSelectManager.handleEditSelect}
                                onCancel={requestDeptNameSelectManager.handleCancelEdit}
                                onSave={requestDeptNameSelectManager.handleSaveSelect}
                                onConfirmValidation={requestDeptNameSelectManager.handleConfirmValidation}
                                onCancelValidation={requestDeptNameSelectManager.handleCancelValidation}
                                onConfirmWithReason={requestDeptNameSelectManager.handleConfirmWithReason}
                                onCancelWithReason={requestDeptNameSelectManager.handleCancelWithReason}
                                onValueChange={requestDeptNameSelectManager.setEditedValue}
                                allowEdit={allowEdit}
                            />
                        </Col>
                        <Col
                            xs={8}
                            className="d-flex align-items-center text-lable-input mb-3"
                        >
                            <LabelRequired label="Chẩn đoán" className="min-w-100px" />
                            <span className="fw-light text-truncate">
                                {selectedPhieu?.provisionalDiagnosisName || "..."}
                            </span>
                        </Col>
                    </Row>
                </div>

                <div className="bg-white pt-2 mb-2">
                    <DanhSachPhieu
                        className="mb-2"
                        handleSelectRowData={handleSelectPhieu}
                        dsPhieu={dsPhieu as []}
                        selectedIndex={selectedIndex}
                    />

                    <div className="tableLichSu border">
                        <Formik initialValues={{}} onSubmit={() => { }}>
                            <TableCustom<any>
                                className={`spaces h-calc-vh-${generalInfo?.isKhamDoan ? "395" : "503"}`}
                                selectionMode={SELECTION_MODE.SINGLE_NO_RADIO_BUTTON}
                                columns={columns}
                                data={dsXetNghiemDetail || []}
                            />
                        </Formik>
                    </div>
                    <div className="d-flex justify-content-between spaces p-6 gap-50 bg-white">
                        <div className="d-flex">
                            {visit?.id &&
                                patient?.id &&
                                selectedPhieu?.id &&
                                WORKFLOW_ORDER_GROUP_STATUS_CODE.HUY_GUI_PHIEU !== currentStatusWf && (
                                    <ButtonInPhieu
                                        className="spaces mx-3"
                                        label="Phiếu chỉ định (F2)"
                                        fetchExport={inPhieuChiDinhDVKhac}
                                        params={{
                                            visitId: visit?.id,
                                            orderGroupId: selectedPhieu?.id,
                                        }}
                                        keyBtn={KEY.F2}
                                    />
                                )}
                            {selectedPhieu?.isAllowModify && !isConclusion && (
                                <WfButton
                                    tracker={WfConstTrackerClinical.ORDER_GROUP}
                                    objectId={selectedPhieu?.id}
                                    additionalFunc={actionChanged}
                                    handleClick={handleClickWfButton}
                                    forceRender={isUpdateWorkflow}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
            
            {dynamicData && (
                <DynamicComponentKB
                    data={dynamicData}
                    setData={setDynamicData}
                    onConfirm={handleConfirmDelete}
                    generalInfo={generalInfo}
                    onUpdate={handleUpdate}
                />
            )}
        </Row>
    );
};

export default TabDVKhac;
